import { Box, Typography } from '@mui/material';
import MuiLink from '@mui/material/Link';
import PoweredByBowlsMaster from '../poweredByBowlsMaster';
import QRCodeData from './qrCodeData';

const styles = `
  .portal-qr-print-sheet {
    background: #fff;
    color: #000;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
  }

  .portal-qr-print-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
  }

  .portal-qr-print-card {
    background: #fff;
    color: #000;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .portal-qr-print-card svg {
    display: block;
  }

  @media print {
    @page {
      margin: 10mm;
    }

    html,
    body {
      background: #fff !important;
    }

    body * {
      visibility: hidden !important;
    }

    .portal-qr-print-sheet,
    .portal-qr-print-sheet * {
      visibility: visible !important;
    }

    .portal-qr-print-sheet {
      display: flex !important;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 20px;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      margin: 0;
      padding: 20px !important;
      border: 0;
      border-radius: 0;
      color: #000 !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .portal-qr-print-group {
      display: contents !important;
    }

    .portal-qr-print-grid {
      display: flex !important;
      flex-wrap: wrap !important;
      justify-content: flex-start !important;
      gap: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .portal-qr-print-card {
      break-inside: avoid;
      page-break-inside: avoid;
      margin: 10px !important;
      border: 2px solid #000 !important;
      color: #000 !important;
      background: #fff !important;
    }

    .portal-qr-print-card * {
      color: #000 !important;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    .no-print {
      display: none !important;
    }
  }
`;

const PrintableQRCodes = ({ groups = [], linkLabel = 'View Game', eventName = '' }) => (
  <>
    <style>{styles}</style>
    <Box className="portal-qr-print-sheet">
      {groups.map((group) => (
        <Box key={group.key} className="portal-qr-print-group" mb={3}>
          {group.heading && (
            <Typography
              className="portal-qr-print-group-heading no-print"
              variant="h5"
              gutterBottom
              width="100%"
              textAlign="center"
              mt={2}
              mb={1}>
              {group.heading}
            </Typography>
          )}

          <Box className="portal-qr-print-grid">
            {group.items.map((item) => (
              <Box
                key={item.key}
                className="portal-qr-print-card"
                display="flex"
                sx={{ border: '2px solid', borderColor: 'primary.main' }}
                m={1}
                p="5px"
                justifyContent="center"
                alignItems="center"
                flexDirection="column">
                <Typography variant="h4" gutterBottom>
                  {item.label}
                </Typography>
                <Box px="20px">
                  <QRCodeData
                    value={item.value}
                    style={{ width: '130px', height: '130px' }}
                  />
                </Box>
                <MuiLink
                  href={item.value}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="no-print">
                  <Typography variant="body1" color="primary">
                    {linkLabel}
                  </Typography>
                </MuiLink>

                <Box mt="16px">
                  <PoweredByBowlsMaster width="120px" />
                </Box>
                {eventName && (
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    fontSize="8px"
                    component="span">
                    {eventName}
                  </Typography>
                )}
                {item.caption && (
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    fontSize="8px"
                    component="span">
                    {item.caption}
                  </Typography>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  </>
);

export default PrintableQRCodes;
